/* eslint-disable react/require-default-props */
import React from 'react'
import * as S from './styles'
import { IGatsbyImageData } from 'gatsby-plugin-image'
import { convertToBgImage } from 'gbimage-bridge'

interface ImageProps {
  readonly image?: IGatsbyImageData
  readonly imageUrl?: string
  readonly color?: string
  readonly className?: string
  readonly children?: React.ReactNode
}

const Image: React.FC<ImageProps> = ( {
  image = null,
  imageUrl = null,
  color = null,
  className = '',
  children = null
} ) => {
  if ( image ) {
    const bannerImage = convertToBgImage( image )
    return (
      <S.Image
        { ...bannerImage }
        className={ className }
      >
        {children}
      </S.Image>
    )
  } else if ( imageUrl?.startsWith( 'http' ) ) {
    return (
      <S.StyledImageDiv
        imageUrl={ imageUrl }
        className={ className }
      >
        {children}
      </S.StyledImageDiv>
    )
  } else if ( color ) {
    return (
      <S.Container
        className={ className }
        style={{ 'backgroundColor': color }}
      >
        {children}
      </S.Container>
    )
  } else {
    return (
      <S.Container
        className={ className }
      >
        {children}
      </S.Container>
    )
  }
}

export default Image
